import { MissionCard } from '@/features/missions/components/MissionCard'
import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { SCREEN_SIZE, useMediaQuery } from '@/ui-kit/media'
import { Trans } from '@lingui/react/macro'
import clsx from 'clsx'
import { useLinkedNectarProjects } from '../api'
import { nectarProjectToMission } from '../api/normalizer'

type LinkedMissionsProps = {
  projectId: string
  className?: string
}

const CARD_WIDTH_MOBILE = 320
const CARD_WIDTH = 382

export const LinkedMissions = ({ projectId, className }: LinkedMissionsProps) => {
  const { missionsUrl } = useMissionsUrl()
  const isMobile = useMediaQuery(SCREEN_SIZE.MOBILE)

  const { data: { data: linkedProjects } = { data: [] } } = useLinkedNectarProjects(projectId)
  const linkedMissions = linkedProjects.map((p) => nectarProjectToMission(p, missionsUrl))

  if (linkedMissions.length === 0) return null

  const gridStyle = {
    gridTemplateColumns: `repeat(auto-fill,${isMobile ? `max(${CARD_WIDTH_MOBILE}px, calc(100vw - 40px))` : `${CARD_WIDTH}px`})`
  }

  return (
    <div className={clsx(className, 'mt-6 flex w-full flex-col gap-3 border-t border-solid border-gray-100 pt-6')}>
      <div className="text-gray-70 mr-auto mb-2 font-semibold">
        <Trans>Related missions</Trans>
      </div>
      <ul className="grid gap-4" style={gridStyle}>
        {linkedMissions.map((mission) => (
          <MissionCard key={mission.id} mission={mission} isMinified />
        ))}
      </ul>
    </div>
  )
}
